<template>
  <hm-content title="">
    <el-radio-group
      class="mb20"
      size="small"
      v-model="switchType"
      @change="switchChange"
      v-if="!isBtn('SET_SYSTEM_PARAM_INFO')"
    >
      <el-radio-button label="0">数据同步</el-radio-button>
      <el-radio-button label="1">系统参数配置</el-radio-button>
    </el-radio-group>
    <div v-if="switchType === '0'">
      <el-popover placement="top-start" width="200" trigger="hover">
        <div v-html="html"></div>
        <span slot="reference" class="ml10">
          <i class="el-icon-question" style="fontsize: 20px"></i>
        </span>
      </el-popover>
      <ul class="ds">
        <li class="flex flex-wrap item-center" v-for="(v, i) in list" :key="i">
          <template v-if="!isBtn(v.type)">
            <div class="title">{{ v.typeName }}：</div>

            <el-date-picker
              v-if="v.type === 'POSORDER'"
              v-model="searchCondition[v.type]"
              type="datetimerange"
              align="right"
              start-placeholder="请选择下单时间单段"
              end-placeholder="请选择下单时间单段"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              size="small"
              class="mr10"
            ></el-date-picker>
            <el-input
              v-else-if="v.type !== 'HEMIAO_BARCODES'"
              clearable
              style="width: 400px"
              v-model.trim="searchCondition[v.type]"
              :placeholder="v.typePlaceholder"
              size="small"
              class="ipt mr10"
            >
            </el-input>
            <el-button
              type="primary"
              size="small"
              @click="search(v.type)"
              v-if="v.type !== 'HEMIAO_BARCODES'"
              >同 步</el-button
            >
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="v.html !== ''"
            >
              <div v-html="v.html"></div>
              <span slot="reference" class="ml10">
                <i class="el-icon-question" style="fontsize: 20px"></i>
              </span>
            </el-popover>

            <div v-if="v.type === 'ATTACH_BARCODES'">
              <div class="flex flex-center">
                <div @click="outputExcel" class="delete mr20 pointer">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  导出模板
                </div>
                <div class="delete mr20 pointer open-file">
                  <span class="delete-icon hmicon icon-daoru"></span>
                  导入
                  <input
                    type="file"
                    @change="importf"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                </div>
              </div>
            </div>

            <div v-if="v.type === 'HEMIAO_BARCODES'">
              <div class="flex flex-center">
                <div @click="outputExcel2" class="delete mr20 pointer">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  导出模板
                </div>
                <div class="delete mr20 pointer open-file">
                  <span class="delete-icon hmicon icon-daoru"></span>
                  导入
                  <input
                    type="file"
                    @change="importf2"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                </div>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div v-else>
      <div class="flex flex-end item-center mb10">
        <el-input
          class="mr10"
          size="small"
          clearable
          placeholder="输入参数说明"
          v-model.trim="searchConditionList.paramRemark"
          style="width: 250px"
        ></el-input>
        <el-input
          class="mr10"
          size="small"
          clearable
          placeholder="输入商城编码"
          v-model.trim="searchConditionList.storeCode"
          style="width: 250px"
        ></el-input>
        <el-input
          class="mr10"
          size="small"
          clearable
          placeholder="输入参数编码"
          v-model.trim="searchConditionList.paramCode"
          style="width: 250px"
        ></el-input>
        <el-input
          class="mr10"
          size="small"
          clearable
          placeholder="输入参数值"
          v-model.trim="searchConditionList.paramValue"
          style="width: 250px"
        ></el-input>
        <el-button type="primary" size="small" @click="searchList"
          >查询</el-button
        >
        <el-button
          v-if="currentStoreCode === '42010216070190'"
          type="primary"
          size="small"
          @click="openAdd"
          >新增</el-button
        >
      </div>
      <el-table
        :data="pageList"
        stripe
        border
        lazy
        style="width: 100%"
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          prop="paramRemark"
          label="参数说明"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="paramCode"
          label="参数编码"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="paramValue"
          label="参数值"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="optionValues"
          label="可选值"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="configType"
          label="配置类型"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.configType === 'system'">系统</span>
            <span v-else-if="scope.row.configType === 'store'">商城</span>
            <span v-else-if="scope.row.configType === 'supplier'">供货商</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="storeCode"
          label="商城编码"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="编辑参数"
      :visible.sync="dialogVisible"
      width="600px"
      @close="close"
    >
      <div slot="title">
        <span class="mr10">编辑参数</span>
      </div>
      <div class="flex tabs">
        <el-form :model="currentRow" ref="currentRow" label-width="130px">
          <el-form-item label="商城编码：" prop="storeCode">
            <el-input
              type="text"
              v-model.trim="currentRow.storeCode"
              clearable
              placeholder="请输入商城编码"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数编码：" prop="paramCode">
            <el-input
              type="text"
              v-model.trim="currentRow.paramCode"
              clearable
              placeholder="请输入参数编码"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数值：" prop="paramValue">
            <el-input
              type="textarea"
              v-model.trim="currentRow.paramValue"
              clearable
              placeholder="请输入参数值"
              size="small"
              :rows="3"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数说明：" prop="paramRemark">
            <el-input
              type="text"
              v-model.trim="currentRow.paramRemark"
              clearable
              placeholder="请输入参数说明"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="配置类型：" prop="configType">
            <el-select
              v-model="currentRow.configType"
              placeholder="请选择配置类型"
              size="small"
              style="width: 350px"
            >
              <el-option label="系统" value="system"></el-option>
              <el-option label="平台" value="platform"></el-option>
              <el-option label="商城" value="store"></el-option>
              <el-option label="供货商" value="supplier"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配置类：" prop="configClass">
            <el-input
              type="text"
              v-model.trim="currentRow.configClass"
              clearable
              placeholder="请输入配置类"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="可选值：" prop="optionValues">
            <el-input
              type="textarea"
              v-model.trim="currentRow.optionValues"
              clearable
              placeholder="请输入可选值"
              size="small"
              :rows="3"
              style="width: 350px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="confirm"
          >确 定</el-button
        >
        <el-button size="small" @click="close">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新增参数"
      :visible.sync="addVisible"
      width="600px"
      @close="closeAdd"
    >
      <div slot="title">
        <span class="mr10">新增参数</span>
      </div>
      <div class="flex tabs">
        <el-form :model="addRow" ref="addRow" label-width="130px">
          <el-form-item label="商城编码：" prop="storeCode">
            <el-input
              type="text"
              v-model.trim="addRow.storeCode"
              clearable
              placeholder="请输入商城编码"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数编码：" prop="paramCode">
            <el-input
              type="text"
              v-model.trim="addRow.paramCode"
              clearable
              placeholder="请输入参数编码"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数值：" prop="paramValue">
            <el-input
              type="textarea"
              v-model.trim="addRow.paramValue"
              clearable
              placeholder="请输入参数值"
              size="small"
              :rows="3"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数说明：" prop="paramRemark">
            <el-input
              type="text"
              v-model.trim="addRow.paramRemark"
              clearable
              placeholder="请输入参数说明"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="配置类型：" prop="configType">
            <el-select
              v-model="addRow.configType"
              placeholder="请选择配置类型"
              size="small"
              style="width: 350px"
            >
              <el-option label="系统" value="system"></el-option>
              <el-option label="平台" value="platform"></el-option>
              <el-option label="商城" value="store"></el-option>
              <el-option label="供货商" value="supplier"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配置类：" prop="configClass">
            <el-input
              type="text"
              v-model.trim="addRow.configClass"
              clearable
              placeholder="请输入配置类"
              size="small"
              style="width: 350px"
            ></el-input>
          </el-form-item>
          <el-form-item label="可选值：" prop="optionValues">
            <el-input
              type="textarea"
              v-model.trim="addRow.optionValues"
              clearable
              placeholder="请输入可选值"
              size="small"
              :rows="3"
              style="width: 350px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="confirmAdd"
          >确 定</el-button
        >
        <el-button size="small" @click="closeAdd">取 消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import XLSX from "xlsx";
import { arrayUnique2 } from "@/utils/utils";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      list: [
        {
          type: "BRAND",
          typeName: "品牌",
          typePlaceholder: "请输入品牌名/编号",
          html: "",
        },
        {
          type: "BRANCH",
          typeName: "机构",
          typePlaceholder: "请输入机构名称",
          html: "",
        },
        {
          type: "DEPART",
          typeName: "部门",
          typePlaceholder: "请输入部门名称",
          html: "",
        },
        {
          type: "SHOP",
          typeName: "商店",
          typePlaceholder: "请输入商店名称",
          html: "",
        },
        {
          type: "DEPOT",
          typeName: "仓库",
          typePlaceholder: "请输入仓库名称",
          html: "",
        },
        {
          type: "EMPLOYEE",
          typeName: "雇员",
          typePlaceholder: "请输入雇员名称",
          html: "",
        },
        {
          type: "CATEGORY",
          typeName: "类目",
          typePlaceholder: "请输入类目",
          html: "",
        },
        {
          type: "SPEC",
          typeName: "规格",
          typePlaceholder: "请输入规格",
          html: "",
        },
        {
          type: "ASSISTATTRIBUTE",
          typeName: "辅助属性",
          typePlaceholder: "请输入辅助属性",
          html: "",
        },
        {
          type: "SINGLESPECGOODS",
          typeName: "单规格商品",
          typePlaceholder: "请输入单规格商品",
          html: "",
        },
        {
          type: "MULTISPECGOODS",
          typeName: "多规格商品",
          typePlaceholder: "请输入多规格商品",
          html: "",
        },
        {
          type: "CARDTYPE",
          typeName: "卡类型",
          typePlaceholder: "请输入卡类型",
          html: "",
        },
        {
          type: "WITHMOBILE",
          typeName: "有手机号会员",
          typePlaceholder: "请输入会员手机号",
          html: "",
        },
        {
          type: "POSORDER",
          typeName: "订单",
          typePlaceholder: "请输入时间段",
          html: "",
        },
        {
          type: "POSORDER_SN",
          typeName: "订单号",
          typePlaceholder: "请输入订单号",
          html: "",
        },
        {
          type: "STOCK",
          typeName: "货号同步库存",
          typePlaceholder: "请输入货号",
          html: "",
        },
        {
          type: "ATTACH_BARCODES",
          typeName: "附加码同步一品多码",
          typePlaceholder: "请输入附加码",
          html: "",
        },
        {
          type: "HEMIAO_BARCODES",
          typeName: "禾苗编码同步一品多码",
          typePlaceholder: "请输入禾苗编码",
          html: "",
        },
      ],
      searchCondition: {
        POSORDER: [],
      },
      html: "",
      tBody: ["hemiaocode", "goodsSn"],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pageList: [],
      currentRow: {},
      dialogVisible: false,
      addRow: {},
      addVisible: false,
      searchConditionList: {
        paramRemark: "",
        storeCode: "",
        paramCode: "",
        paramValue: "",
      },
      switchType: "0",
      resetForm: true,
      currentStoreCode: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getHtml();
    const { storeCode } = getLoginUser();
    console.log("storeCode", storeCode);
    this.currentStoreCode = storeCode || "";
    if (
      storeCode &&
      ("42010216070190" == storeCode || "53010017032439" == storeCode)
    ) {
      this.getAttachBarcodes();
    }
    this.storeSystemParamInfoQueryPageList();
  },
  methods: {
    getHtml() {
      this.getRemark();
      this.getBrand();
      this.getBranch();
      this.getDepart();
      this.getShop();
      this.getDepot();
      this.getEmployee();
      this.getCategory();
      this.getSpec();
      this.getAssistattribute();
      this.getSinglespecgoods();
      this.getCardtype();
      this.getWithmobile();
      this.getPosorder();
      this.getGoodsSn();
    },
    async getRemark() {
      const { result } = await this.$store.dispatch("getRemark");
      this.html = result;
    },
    async getBrand() {
      const { result } = await this.$store.dispatch("getBrand");
      this.list[0].html = result;
    },
    async getBranch() {
      const { result } = await this.$store.dispatch("getBranch");
      this.list[1].html = result;
    },
    async getDepart() {
      const { result } = await this.$store.dispatch("getDepart");
      this.list[2].html = result;
    },
    async getShop() {
      const { result } = await this.$store.dispatch("getShop");
      this.list[3].html = result;
    },
    async getDepot() {
      const { result } = await this.$store.dispatch("getDepot");
      this.list[4].html = result;
    },
    async getEmployee() {
      const { result } = await this.$store.dispatch("getEmployee");
      this.list[5].html = result;
    },
    async getCategory() {
      const { result } = await this.$store.dispatch("getCategory");
      this.list[6].html = result;
    },
    async getSpec() {
      const { result } = await this.$store.dispatch("getSpec");
      this.list[7].html = result;
    },
    async getAssistattribute() {
      const { result } = await this.$store.dispatch("getAssistattribute");
      this.list[8].html = result;
    },
    async getSinglespecgoods() {
      const { result } = await this.$store.dispatch("getSinglespecgoods");
      this.list[9].html = result;
      this.list[10].html = result;
    },
    async getCardtype() {
      const { result } = await this.$store.dispatch("getCardtype");
      this.list[11].html = result;
    },
    async getWithmobile() {
      const { result } = await this.$store.dispatch("getWithmobile");
      this.list[12].html = result;
    },
    async getPosorder() {
      const { result } = await this.$store.dispatch("getPosorder");
      this.list[13].html = result;
      this.list[14].html = result;
    },
    async getGoodsSn() {
      const { result } = await this.$store.dispatch("getGoodsSn");
      this.list[15].html = result;
    },
    async getAttachBarcodes() {
      const { result } = await this.$store.dispatch("getGoodsByAttachBarcodes");
      this.list[16].html = result;
    },
    async getAttachBarcodes() {
      const { result } = await this.$store.dispatch("getGoodsbyhemiaocodes");
      this.list[17].html = result;
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    async search(prop) {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      let params = {};
      if (searchCondition[prop] && searchCondition[prop] !== "") {
        if (prop === "POSORDER") {
          params[prop] =
            this.searchCondition[prop].length > 0
              ? this.searchCondition[prop].join("|")
              : "";
        } else if (prop === "POSORDER_SN") {
          prop = "POSORDER";
          params[prop] = searchCondition.POSORDER_SN;
        } else {
          if (prop === "STOCK") {
            params.goodsSn = searchCondition[prop];
          } else if (prop === "ATTACH_BARCODES") {
            params.attachBarcodes = searchCondition[prop];
          } else {
            params[prop] = searchCondition[prop];
          }
        }
        params.syncFuncId = prop;
        params.syncTargetId = params[prop];
        let name = "";
        if (prop === "STOCK") {
          name = "syncTargetGoodsSn";
        } else if (prop === "ATTACH_BARCODES") {
          name = "syncGoodsByAttachBarcodes";
        } else {
          name = "syncTargetId";
        }
        const { code, inMsg } = await this.$store.dispatch(name, params);

        if (code === "0") {
          this.$message({
            message: inMsg,
            type: "success",
          });
        }
      }
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["附加码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "附加码模板");
      });
    },
    outputExcel2() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["禾苗编码", "货号"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "禾苗编码同步一品多码模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let attachBarcodesList = [];
        result.forEach((v) => {
          if (v[0]) {
            attachBarcodesList.push(v[0]);
          }
        });

        // goodsSns = unique(goodsSns);
        that.$store
          .dispatch("attrBarCodeImport", { attachBarcodesList })
          .then((res) => {
            const { code, result } = res;
            let type = "warning";
            if (code === "0") {
              type = "success";
            }
            console.log(type);
            that.$message({
              message: result,
              type: type,
            });
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    importf2(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let importHemiaocodes = [];
        result.map((v, i) => {
          importHemiaocodes.push({});
          that.tBody.map((o, index) => {
            importHemiaocodes[i][that.tBody[index]] = v[index];
          });
        });
        console.log("importHemiaocodes:", importHemiaocodes);
        // goodsSns = unique(goodsSns);
        that.$store
          .dispatch("importGoodsByHemiaocodes", { importHemiaocodes })
          .then((res) => {
            const { code, result } = res;
            let type = "warning";
            if (code === "0") {
              type = "success";
            }
            console.log(type);
            that.$message({
              message: result,
              type: type,
            });
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    async storeSystemParamInfoQueryPageList() {
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionList)
      );
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "storeSystemParamInfoQueryPageList",
        params
      );
      if (code === "0") {
        console.log("result:", result);
        this.pageList = result.records;
        this.total = result.total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.storeSystemParamInfoQueryPageList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.storeSystemParamInfoQueryPageList();
    },
    edit(row) {
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    async confirm() {
      const result = await this.$confirm("是否修改本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        let params = {
          id: this.currentRow.id,
          storeCode: this.currentRow.storeCode,
          paramCode: this.currentRow.paramCode,
          paramValue: this.currentRow.paramValue,
          paramRemark: this.currentRow.paramRemark,
          configType: this.currentRow.configType,
          configClass: this.currentRow.configClass,
          optionValues: this.currentRow.optionValues,
        };
        const { code } = await this.$store.dispatch("editValueById", params);
        if (code === "0") {
          this.storeSystemParamInfoQueryPageList();
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialogVisible = false;
        }
      }
    },
    close() {
      this.dialogVisible = false;
    },
    openAdd() {
      this.addRow = {};
      this.addVisible = true;
    },
    async confirmAdd() {
      const result = await this.$confirm("是否新增该条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        let params = {
          storeCode: this.addRow.storeCode,
          paramCode: this.addRow.paramCode,
          paramValue: this.addRow.paramValue,
          paramRemark: this.addRow.paramRemark,
          configType: this.addRow.configType,
          configClass: this.addRow.configClass,
          optionValues: this.addRow.optionValues,
        };
        const { code } = await this.$store.dispatch(
          "storeSystemParamInfoAdd",
          params
        );
        if (code === "0") {
          this.storeSystemParamInfoQueryPageList();
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.addVisible = false;
        }
      }
    },
    closeAdd() {
      this.addVisible = false;
    },
    searchList() {
      this.storeSystemParamInfoQueryPageList();
    },
    switchChange(e) {
      if (e === "1") {
        this.resetForm = false
        this.$nextTick(()=>{
            this.resetForm = true;
        })
        this.currentPage = 1;
        this.storeSystemParamInfoQueryPageList();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ds {
  > li {
    margin-bottom: 20px;
    .title {
      text-align: right;
      width: 160px;
    }
  }
}
</style>
